module.exports = __webpack_public_path__ + "static/img/bg-id.d26eb044.png";